import { httpGet, httpGetFile } from './api.service';
import { GetSightingsRequest } from '../requestModels/getSightingsRequest';
import { PaginatedResult } from '../types/PaginatedResult';
import { Sighting } from '../types/Sighting';
import { GeoPosition } from '../types/GeoPosition';

const getSightings = async (request: GetSightingsRequest): Promise<PaginatedResult<Sighting>> => {
  return await httpGet<PaginatedResult<Sighting>>(`api/sentinelsightings`, request);
};

const getProcessedSightingByReportId = async (request: GetSightingsRequest): Promise<PaginatedResult<Sighting>> => {
  if (request.showUnpaired) {
    return Promise.resolve({ skipped: 0, count: 0, totalCount: 0, results: [], status: 200 });
  } else {
    return await httpGet<PaginatedResult<Sighting>>(`api/sightingprocessed/`, request);
  }
};

const getProcessedSightingLocationsByReportId = async (reportId: string): Promise<GeoPosition[]> => {
  return await httpGet<GeoPosition[]>(`api/sightingprocessed/report/${reportId}`);
};

const exportProcessedSightingByReportId = async (request: GetSightingsRequest): Promise<void> => {
  return await httpGetFile(`api/sightingprocessed/export`, request);
};

const getFailedSightingByReportId = async (request: GetSightingsRequest): Promise<PaginatedResult<Sighting>> => {
  return await httpGet<PaginatedResult<Sighting>>(`api/sightingfailed/`, request);
};

const getUnprocessSightingByReportId = async (request: GetSightingsRequest): Promise<PaginatedResult<Sighting>> => {
  return await httpGet<PaginatedResult<Sighting>>(`api/sightingUnprocess/`, request);
};

const getLatestSightings = async (request: GetSightingsRequest): Promise<PaginatedResult<Sighting>> => {
  return await httpGet<PaginatedResult<Sighting>>(`api/sightinglatest`, request);
};

const exportSightings = (request: GetSightingsRequest): Promise<void> => {
  return httpGetFile(`api/sightinglatest/export`, request);
};

const getSightingsByVisitId = (params: Record<string, any>): Promise<PaginatedResult<Sighting>> => {
  const query = Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  return httpGet<PaginatedResult<Sighting>>(`api/SightingProcessed?${query}`);
};

export {
  getSightings,
  exportProcessedSightingByReportId,
  exportSightings,
  getProcessedSightingByReportId,
  getProcessedSightingLocationsByReportId,
  getFailedSightingByReportId,
  getUnprocessSightingByReportId,
  getLatestSightings,
  getSightingsByVisitId,
};
